import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Grid } from '@material-ui/core';
import {
  Container, LoadingBounce, Panel,
} from '@michelin/acid-components';
import { useTranslation } from '@michelin/central-provider';
import useUtils from 'hooks/useUtils';
import useService from 'hooks/useService';
import usePermissionsSPP from 'hooks/usePermissionsSPP';
import { ChangeLogEntities } from 'Types';
import LastModified from 'components/ChangeLog/LastModified';
import { useLocationST } from 'hooks/useLocation';
import { PageTitle } from 'Utils/CanvasPageTitle';
import ServicesPanel from './ServicesPanel';

interface ServiceDetailsProps {
  action: string,
  countryCode: string,
}

export function ServiceDetails(props: ServiceDetailsProps) {
  const { stNumber } = useParams<{ stNumber: string }>();
  const { t } = useTranslation();
  const { subTitle } = useUtils();
  const permissions = usePermissionsSPP();
  const history = useHistory();
  const serviceQuery = useService(stNumber);
  const stLocationQuery = useLocationST(stNumber);

  if (serviceQuery.isLoading || stLocationQuery.isLoading || permissions.isLoading) { return <LoadingBounce style={{ height: '70vh' }} />; }

  if (!permissions.allowsAction('services.read', true)) {
    history.push('/');
  }

  return (
    <>
      <PageTitle
        title={t('Services')}
        subtitle={subTitle}
        rightItems={(<LastModified entity={ChangeLogEntities.services} />)}
      />
      <Container>
        <Panel>
          <Grid container spacing={2} style={{ paddingTop: 5, paddingBottom: 60 }}>
            <ServicesPanel
              action={props.action}
              countryCode={props.countryCode}
              data={serviceQuery.data}
              mobile_only={stLocationQuery.data.mobile_only}
            />
          </Grid>
        </Panel>
      </Container>
    </>
  );
}
